/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_HubspotInputs */

const en_waiting_on_hubspot = /** @type {(inputs: Waiting_On_HubspotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on HubSpot`)
};

/**
* | output |
* | --- |
* | "on HubSpot" |
*
* @param {Waiting_On_HubspotInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_hubspot = /** @type {((inputs?: Waiting_On_HubspotInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_HubspotInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_hubspot(inputs)
});